module.exports = __webpack_public_path__ + "img/ercode_xianlai.68313821.png";